module.exports = __webpack_public_path__ + "static/media/file-upload.5d39cd77.svg";